import * as React from "react";

import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

export type CalendarProps = React.ComponentProps<typeof DatePicker> & {
  handleChange?: (name: string, value: any) => void;
  id?: string;
};

function Calendar({
  className,
  handleChange,
  value,
  name,
  ...props
}: CalendarProps) {
  const today = new Date();

  const onChange = (value: any) => {
    handleChange(name, value);
  }

  return <LocalizationProvider dateAdapter={AdapterDateFns}>
  <DatePicker
    {...props}
    className={'date-picker'}
    format={"dd/MM/yyy"}
    defaultValue={today}
    value={value}
    onChange={(date) => onChange(date)}
  />
</LocalizationProvider>
}
Calendar.displayName = "Calendar";

export { Calendar };
